import { useState, useEffect, useCallback } from 'react';
import { userCategories as categoriesApi } from '../lib/api';
import { DEFAULT_RECEITA_CATEGORIES, DEFAULT_DESPESA_CATEGORIES } from '../utils/defaultCategories';

export function useCategorias(tipo) {
  const [customCategories, setCustomCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const defaults = tipo === 'receita' ? DEFAULT_RECEITA_CATEGORIES : DEFAULT_DESPESA_CATEGORIES;

  const loadCategories = useCallback(async () => {
    try {
      const data = await categoriesApi.list(tipo);
      setCustomCategories(data);
    } catch (error) {
      console.error('Failed to load custom categories:', error);
    } finally {
      setLoading(false);
    }
  }, [tipo]);

  useEffect(() => {
    loadCategories();
  }, [loadCategories]);

  // Merge: system defaults first, then custom (no duplicates)
  const customNames = customCategories.map(c => c.nome);
  const categories = [
    ...defaults,
    ...customNames.filter(name => !defaults.includes(name)),
  ];

  const addCategory = async (nome) => {
    const trimmed = nome.trim();
    if (!trimmed || categories.includes(trimmed)) return trimmed;
    const created = await categoriesApi.create(trimmed, tipo);
    setCustomCategories(prev => [...prev, created]);
    return trimmed;
  };

  const deleteCategory = async (id) => {
    await categoriesApi.delete(id);
    setCustomCategories(prev => prev.filter(c => c.id !== id));
  };

  return { categories, loading, addCategory, deleteCategory };
}
